import React from 'react';
import { createDevTools } from 'redux-devtools';
import DockMonitor from 'redux-devtools-dock-monitor';
import LogMonitor from 'redux-devtools-log-monitor';

export default createDevTools(
    <DockMonitor toggleVisibilityKey='shift-alt-h'
            changePositionKey='shift-alt-q'
            defaultPosition='right'
            defaultIsVisible={false}>

        <LogMonitor expandActionRoot={false} expandStateRoot={false}/>
    </DockMonitor>
);



// WEBPACK FOOTER //
// ./src/components/DevTools.js